<template>
    <svg viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 70L70 -3.05176e-05L70 70L0 70Z" fill="currentColor"/>
    </svg>
</template>
